import { useCallback } from "react";

import { useQuery } from "hooks";
import { createResolverFactory } from "components/QueryClient/ResolverFactory";

export function usePortalSession() {
  const queryFactory = useCallback(() => {
    const query = `query portalSessionObject {
                    portalSession {
                      accessUrl
                      id
                      token
                      status
                      createdAt
                      expiresAt
                      object
                      customerId
                    }
                  }`;

    const resolver = ({ data }) => {
      return { instance: data.portalSession };
    };

    return { query: query, resolver: createResolverFactory(resolver) };
  }, []);

  return useQuery(queryFactory, { options: { fetchOnInit: false } });
}

export default usePortalSession;
